import api from "api";

const PATH = "/quiz";

const GET_LIST_QUIZ = async () => {
  try {
    const { data } = await api.get(`${PATH}/get-quiz`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const VALIDA_QUIZ_DIA = async () => {
  try {
    const { data } = await api.get(`${PATH}/valida-quiz-dia`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const SUBMIT_QUIZ = async (data) => {
  try {
    const response = await api.post(`${PATH}/submit-quiz`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};
const GET_RESUMO = async () => {
  try {
    const { data } = await api.get(`${PATH}/get-resumo`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export { GET_LIST_QUIZ, VALIDA_QUIZ_DIA, SUBMIT_QUIZ, GET_RESUMO };
